import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function BookIcon(props: IconProps) {
    return <Icon {...props} iconKey={"book"}/>
}
